export interface RoleDetails {
  id: string;
  name: string;
  description: string;
  showSettings: boolean;
}
